import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const OrgContext = createContext(null);

export function OrgProvider({ children }) {
  const { user } = useAuth();
  const [orgs, setOrgs] = useState([]);
  const [currentOrg, setCurrentOrg] = useState(null);
  const [ready, setReady] = useState(false);

  const loadOrgs = useCallback(async () => {
    const { data } = await api.get("/organizations");
    setOrgs(data);
    const saved = localStorage.getItem("growthai_org");
    const found = data.find((o) => o.id === saved) || data[0];
    if (found) {
      setCurrentOrg(found);
      localStorage.setItem("growthai_org", found.id);
    } else {
      setCurrentOrg(null);
    }
    setReady(true);
  }, []);

  useEffect(() => {
    if (user) {
      loadOrgs();
    } else {
      setOrgs([]);
      setCurrentOrg(null);
      setReady(false);
    }
  }, [user, loadOrgs]);

  const switchOrg = (id) => {
    const o = orgs.find((x) => x.id === id);
    if (o) {
      setCurrentOrg(o);
      localStorage.setItem("growthai_org", id);
    }
  };

  const createOrg = async (name, region) => {
    const { data } = await api.post("/organizations", { name, region });
    await loadOrgs();
    switchOrg(data.id);
    return data;
  };

  return (
    <OrgContext.Provider value={{ orgs, currentOrg, ready, switchOrg, createOrg, loadOrgs }}>
      {children}
    </OrgContext.Provider>
  );
}

export const useOrg = () => useContext(OrgContext);
